import { TKey } from "@/app/translations/TKey";

export enum HowItWorksMockKind {
  CAPTURE = "CAPTURE",
  CUSTOMER_FILE = "CUSTOMER_FILE",
  PERSONA = "PERSONA",
  ASSISTANT = "ASSISTANT",
}

export type HowItWorksBlock = {
  mock: HowItWorksMockKind;
  labelKey: TKey;
  titleKey: TKey;
  bulletKeys: TKey[];
};
